export const getUserType = (id: string, userTypes: any[]) => {
  if (!id || id === 'null') {
    return 'All types'
  }

  return userTypes.find(type => type.id === id)?.name ?? 'Unknown type'
}
